import React from 'react';
import PropTypes from 'prop-types';

import { ButtonBase as MUIButtonBase } from '@material-ui/core';

export const ButtonBase = props => <MUIButtonBase {...props} />;

ButtonBase.propTypes = {
  TouchRippleProps: PropTypes.object,
  centerRipple: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  component: PropTypes.elementType,
  disableRipple: PropTypes.bool,
  disableTouchRipple: PropTypes.bool,
  disabled: PropTypes.bool,
  focusRipple: PropTypes.bool,
  onClick: PropTypes.func
};

export default ButtonBase;
